import {
  ReferenceBadge,
  styled,
  Text,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import {
  useGetDisclaimer,
  useIsType6DisclaimersEnabled,
  transformNumberFormat
} from 'src/feature-app/hooks';
import { CarlineWithOffers } from 'src/types';
import { OfferCarlineCardProps } from '.';

const GreyText = styled.div`
  div {
    color: #6a767d;
  }
`;

//transform format offer quota

const getLowestPriceOffer = (carline: CarlineWithOffers) => {
  let lowestPriceOffer: CarlineWithOffers['ofertas'][0] | undefined;

  carline.ofertas.forEach((oferta) => {
    if (oferta.myWay.activo === 1 && oferta.financiacionText !== 'Ocasión') {
      if (!lowestPriceOffer || Number(oferta.cuota) < Number(lowestPriceOffer.cuota)) {
        lowestPriceOffer = oferta;
      }
    }
    else if (oferta.myWay.activo !== 1 && oferta.financiacionText !== 'Ocasión') {
      if (!lowestPriceOffer) {
        lowestPriceOffer = oferta;
      }
    }
  });
  return lowestPriceOffer;
};

export const OfferCarlineCardInfo = (props: OfferCarlineCardProps) => {

  const { carline, selectedCarlineId, offerPackageArray } = props;
  const [isSelected, setIsSelected] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(() => getLowestPriceOffer(carline));
  const disclaimer = useGetDisclaimer(selectedOffer?.legal);
  const isType6DisclaimersEnabled = useIsType6DisclaimersEnabled();

  useEffect(() => {
    selectedCarlineId === carline.code ? setIsSelected(true) : setIsSelected(false);
  }, [selectedCarlineId]);

  useEffect(() => {
    selectedCarlineId === carline.code ? setIsSelected(true) : setIsSelected(false);
  }, [offerPackageArray]);

  const transformedEntrada = transformNumberFormat(selectedOffer.cuotaEntrada);
  const transformedFinal =
    selectedOffer.cuotaFinal && selectedOffer.cuotaFinal !== '0'
      ? transformNumberFormat(selectedOffer.cuotaFinal)
      : null;

  const transformedTinTae = (num: string) => {
    let finalNumber;

    if (num.includes('.')) {
      const aux = num.toString().split('.');

      if (aux[1].length === 2) {
        finalNumber = `${aux[0]},${aux[1]}`;
      } else if (aux[1].length === 1) {
        finalNumber = `${aux[0]},${aux[1]}0`;
      } else {
        finalNumber = `${aux[0]},00`;
      }
    } else {
      finalNumber = `${num},00`;
    }

    return finalNumber;
  };

  const getTime = (): string => {
    const cuotaTipo = selectedOffer.cuotaTipo;
    const tipo = {
      diaria: '/dia',
      mensual: '/mes',
      ninguna: '',
    };
    return tipo[cuotaTipo];
  };

  const transformedCuota =  new Intl.NumberFormat('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2}).format(selectedOffer.cuota);

  return (
    <>
      {isSelected ? null : (
        <div>
          <Text appearance={TokenTextAppearance.copy200} staticSize>
            <Text bold>
              Desde {transformedCuota}€{getTime()}
              {isType6DisclaimersEnabled ? (
                <Text sup>
                  <ReferenceBadge onClick={(e) => {
                    e.stopPropagation();
                    disclaimer.onClick();
                  }}
                  >{disclaimer?.ref}</ReferenceBadge>
                </Text>
              ) : (
                <Text appearance={TokenTextAppearance.copy100} sup>
                  {disclaimer?.ref}
                </Text>
              )}
            </Text>
            &nbsp;{selectedOffer.financiacionText}
          </Text>
          {selectedOffer.next === 1 || selectedOffer.myRenting === 1 || selectedOffer.myWay.activo === 1 ? (
            <GreyText>
              <Text appearance={TokenTextAppearance.copy100} staticSize>
                {
                  selectedOffer.myRenting === 1 || selectedOffer.myWay.activo === 1 &&
                  <>
                    <Text bold color={TokenTextColor.inherit}>{selectedOffer.plazos} meses{' '}|{' '}</Text>
                  </>
                }

                <Text bold color={TokenTextColor.inherit}>
                  {transformedEntrada}€
                </Text>{' '}
                de entrada{' '}

                {selectedOffer.ivaIncluido === 1 && selectedOffer.myRenting === 1 ?
                  <span style={{ whiteSpace: 'nowrap' }}>(IVA incluido)</span>
                  : selectedOffer.myRenting === 1 ? <span style={{ whiteSpace: 'nowrap' }}>(sin IVA)</span>
                    : null
                }
                {
                  selectedOffer.next === 1 && transformedFinal ? (
                    <>
                      <Text bold color={TokenTextColor.inherit}>
                        | {transformedFinal}€
                      </Text>{' '}
                      cuota final
                    </>
                  ) : selectedOffer.myWay.activo === 1 && transformedFinal ? (
                    <GreyText>
                      <Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.inherit}>
                        {transformedFinal}€ de cuota final
                      </Text>
                    </GreyText>
                  ) : null
                }
              </Text>
              {
                selectedOffer.next === 1 ? (
                  <>
                    <Text appearance={TokenTextAppearance.copy100} staticSize>
                      <Text bold color={TokenTextColor.inherit}>
                        {selectedOffer.plazos}{' '}
                      </Text>
                      meses{' '}
                      {selectedOffer.next === 1 && selectedOffer.tin && selectedOffer.tae ? (
                        <>
                          <Text bold color={TokenTextColor.inherit}>
                            | <span style={{ borderBottom: '1px solid #6A767D' }}>{transformedTinTae(selectedOffer.tae)}% TAE</span>
                          </Text>{' '}
                          | {transformedTinTae(selectedOffer.tin)}% TIN{' '}
                        </>
                      ) : null}
                    </Text>
                  </>
                ) : null
              }
            </GreyText>
          ) : null}
        </div>
      )}
    </>
  );
};
